import "/@/design/index.less";
import "virtual:windi-base.css";
import "virtual:windi-components.css";
import "virtual:windi-utilities.css";
// Register icon sprite
import "virtual:svg-icons-register";
import App from "./App.vue";
import { createApp } from "vue";
import { initAppConfigStore } from "/@/logics/initAppConfig";
import { setupErrorHandle } from "/@/logics/error-handle";
import { router, setupRouter } from "/@/router";
import { setupRouterGuard } from "/@/router/guard";
import { setupStore } from "/@/store";
import { setupGlobDirectives } from "/@/directives";
import { registerGlobComp } from "/@/components/registerGlobComp";

// Importing on demand in local development will increase the number of browser requests by around 20%.
// This may slow down the browser refresh speed.
// Therefore, only enable on-demand importing in production environments .
if (import.meta.env.DEV) {
  import("ant-design-vue/dist/antd.less");
}

async function bootstrap() {
  const app = createApp(App);

  // Configure store
  setupStore(app);

  // Initialize internal system configuration
  initAppConfigStore();

  // Register global components
  registerGlobComp(app);

  // Configure routing
  setupRouter(app);

  // router-guard
  setupRouterGuard(router);

  // Register global directive
  setupGlobDirectives(app);

  // Configure global error handling
  setupErrorHandle(app);

  // https://next.router.vuejs.org/api/#isready
  // await router.isReady();

  app.mount("#app");
}

bootstrap();
